import dynamic from 'next/dynamic'

// 创建一个不进行服务器端渲染的组件
const EchoNextImage = dynamic(() => import('./EchoNextImageClient'), {
  ssr: false
})

export default EchoNextImage
